// Imagenes de los catalogos de contexts, materials y postures, por codigo del
// catalogo clinico: context/C-001.png, materials/O-001.png, postures/P-001.png.
// Son opcionales: un elemento sin PNG se pinta sin imagen. Para anadir una
// basta con soltar el fichero en su carpeta con el codigo como nombre.
//
// require.context mete en el bundle solo las URLs; cada imagen se descarga
// cuando se pinta.
const byCode = (ctx) => {
  const images = {};
  ctx.keys().forEach((key) => {
    const code = key.replace(/^\.\/(.*)\.png$/, "$1");
    const mod = ctx(key);
    images[code] = mod.default || mod;
  });
  return images;
};

const catalogImages = {
  ...byCode(require.context("./context", false, /\.png$/)),
  ...byCode(require.context("./materials", false, /\.png$/)),
  ...byCode(require.context("./postures", false, /\.png$/)),
};

export default catalogImages;
